const filterContainer = document.querySelector('.archive-item-filter');
const filterForm = document.querySelector('.items-filter__filter-posts-form');
if (filterContainer) {
    //Si le viewport est < 768px on ajoute un evenement sur la classe items-filter__title lorsqu'on clique dessus on ajoute la classe is-open à l'élément qui a la classe items-filter__mobile-dropdown
    if (window.innerWidth < 768) {
        const filterTitle = document.querySelector('.items-filter__title');
        const filterTitleArrow = document.querySelector('.items-filter__title-arrow');
        filterTitle.addEventListener('click', (e) => {
            e.preventDefault();
            filterTitle.classList.toggle('is-open');
            filterTitleArrow.classList.toggle('is-open');
            filterContainer.querySelector('.items-filter__mobile-dropdown').classList.toggle('is-open');

        })
    }


    //Dropdown des filtres
    const filtersTopContainer = document.querySelectorAll('.items-filter__dropdown-container__top');
    filtersTopContainer.forEach((filterTopContainer) => {
        filterTopContainer.addEventListener('click', (e) => {
            //On ferme tous les autres dropdowns sauf celui qui a été cliqué
            const otherDropDowns = document.querySelectorAll('.items-filter__dropdown-choices.is-open');
            otherDropDowns.forEach((dropDown) => {
                if (dropDown !== filterTopContainer.parentElement.querySelector('.items-filter__dropdown-choices')) {
                    dropDown.classList.remove('is-open');
                    //On selectionne le parent puis l'icon pour changer la direction de la flèche
                    dropDown.parentElement.querySelector('.items-filter__dropdown-container__icon').classList.remove('is-open');
                }
            })
            e.preventDefault();
            const dropDownChoices = filterTopContainer.parentElement.querySelector('.items-filter__dropdown-choices')
            dropDownChoices.parentElement.querySelector('.items-filter__dropdown-container__icon').classList.toggle('is-open');
            dropDownChoices.classList.toggle('is-open');
        })
    });

    //If it's a taxonomy archive we don't use this script view archive-taxo-filters.js
    const isTaxoArchive = document.querySelector('.archive-main').classList.contains('is-taxo-archive');
    (function ($) {
        $(document).ready(function () {
            //Quand le top du container #items-filter atteint le top du viewport on lui ajoute la classe is-fixed
            let itemsFilter = $('#items-filter');
            let itemsFilterTop = itemsFilter.offset().top;
            let headerHeight = $('.header__top').outerHeight();

            $(window).scroll(function () {
                if ($(window).scrollTop() >= itemsFilterTop - headerHeight) {
                    itemsFilter.addClass('is-fixed');
                    itemsFilter.css('top', headerHeight);
                    $('#items-wrapper').css('padding-top', itemsFilter.outerHeight());
                    $('.items-filter__title').css('margin-bottom', 0);
                } else {
                    itemsFilter.removeClass('is-fixed');
                    $('#items-wrapper').css('padding-top', 0);
                    $('.items-filter__title').css('margin-bottom', 10);
                }
            });


            $(document).click(function (e) {
                if (!$(e.target).closest('.items-filter__dropdown-container').length) {
                    $('.items-filter__dropdown-choices').removeClass('is-open');
                    $('.items-filter__dropdown-container__icon').removeClass('is-open');
                }
            });

            if (!isTaxoArchive) {
                const notFoundContainer = $('.not-found').clone();
                $('.not-found').remove();
                let values = {
                    category: ['*'],
                    post_tag: ['*'],
                    frge_profile: ['*'],
                    frge_podcast_categories: ['*'],
                };

                let nonce = $(filterForm).find('input[name="nonce"]').val();
                let action = $(filterForm).find('input[name="action"]').val();
                let ajaxUrl = $(filterForm).attr('action');
                let postType = $('.archive-main').attr('data-post-type');
                currentPage = 1;
                //On ajoute un evenement pour fermer les dropdowns lorsqu'on clique en dehors


                //On ajoute un evenement sur les span pour ajouter la classe is-selected et ajouter la valeur de l'attribut data-value dans le tableau values
                $('.items-filter__dropdown-choices > span').click(function () {

                    let taxoVal = $(this).attr('data-value');
                    let taxoName = $(this).attr('data-name');


                    ajaxUrl = $(filterForm).attr('action');

                    if (taxoVal === '*') {
                        values[taxoName] = ['*'];
                        $(this).parent().find('span').removeClass('is-selected');
                        $(this).addClass('is-selected');
                    } else {
                        values[taxoName] = values[taxoName].filter((item) => item !== '*');
                    }
                    //Si la taxoVal est déjà dans le tableau, on l'enlève l'objet correspondant du tableau sinon on l'ajoute
                    if (values[taxoName].includes(taxoVal)) {
                        values[taxoName] = values[taxoName].filter((item) => item !== taxoVal);
                    }
                    else {
                        if (postType === 'frge_documents' && taxoName === 'category') {
                            values[taxoName] = [];
                            $(this).parent().find('span').removeClass('is-selected');
                            $(this).parent().find('svg').remove();
                        }
                        values[taxoName].push(taxoVal);

                    }

                    if (values[taxoName].length === 0) {
                        values[taxoName].push('*');
                    }

                    //ON fait une requête fetch pour récupérer les posts correspondants aux filtres
                    fetchPosts(ajaxUrl, values, nonce, action, postType);
                    //On ajoute la classe active à l'élément qui a data-page=currentpage
                    const crossIcon = '<svg stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="items-filter__cross-icon"><path d="M9.17218 14.8284L12.0006 12M14.829 9.17157L12.0006 12M12.0006 12L9.17218 9.17157M12.0006 12L14.829 14.8284" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
                    $(this).toggleClass('is-selected');
                    if ($(this).hasClass('is-selected')) {
                        $(this).prepend(crossIcon);
                    }
                    else {
                        $(this).find('svg').remove();
                    }

                })

                function createPagination(maxPages) {
                    let pagination = $('#pagination');
                    pagination.html('');
                    let paginationList = $('<ul>').addClass('pagination__list');
                    pagination.append(paginationList);

                    let displayPages = maxPages;
                    if (displayPages > 6) {
                        displayPages = 6;
                    }

                    let startPage = 1;
                    if (currentPage > 6) {
                        startPage = currentPage - 1;
                    }

                    if (currentPage > maxPages - 5 && maxPages - 5 > 0) {
                        startPage = maxPages - 5;
                    }

                    for (let i = startPage; i <= maxPages && i < startPage + 6; i++) {
                        let paginationItem = $('<li>').addClass('pagination__item');
                        paginationItem.attr('data-page', i);
                        paginationList.append(paginationItem);
                        let paginationLink = $('<a>').addClass('pagination__link')
                            .attr('href', '#')
                            .text(i);
                        paginationItem.append(paginationLink);

                        if (i === currentPage) {
                            paginationItem.addClass('active');
                        }

                        $(paginationItem).click(function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            //Scroll to top
                            $('html, body').animate({ scrollTop: 0 }, 500);
                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    }

                    if (startPage + 5 < maxPages && maxPages > 6) {
                        let paginationItem = $('<li>').addClass('pagination__item');
                        paginationList.append(paginationItem);
                        let paginationLink = $('<span>').addClass('pagination__link')
                            .text('...');
                        paginationItem.append(paginationLink);
                        let paginationItemLast = $('<li>').addClass('pagination__item');
                        paginationItemLast.attr('data-page', maxPages);
                        paginationList.append(paginationItemLast);
                        let paginationLinkLast = $('<a>').addClass('pagination__link')
                            .attr('href', '#')
                            .text(maxPages);
                        paginationItemLast.append(paginationLinkLast);
                        paginationItemLast.click(function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            $('html, body').animate({ scrollTop: 0 }, 500);

                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    } else if (maxPages > 6) {
                        let paginationItem = $('<li>').addClass('pagination__item');
                        paginationList.prepend(paginationItem);
                        let paginationLink = $('<span>').addClass('pagination__link')
                            .text('...');
                        paginationItem.append(paginationLink);
                        let paginationItemFirst = $('<li>').addClass('pagination__item');
                        paginationItemFirst.attr('data-page', 1);
                        paginationList.prepend(paginationItemFirst);
                        let paginationLinkFirst = $('<a>').addClass('pagination__link')
                            .attr('href', '#')
                            .text(1);
                        paginationItemFirst.append(paginationLinkFirst);
                        paginationItemFirst.click(function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            $('html, body').animate({ scrollTop: 0 }, 500);

                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    }

                    //Prev arrow
                    let prevItem = $('<li>').addClass('pagination__item__prev');
                    let prevLink = $('<a>').addClass('pagination__link__prev')
                        .attr('href', '#')
                        .html('<svg width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M15 6L9 12L15 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>')
                    if (parseInt(currentPage) === 1) {
                        prevItem.addClass('disabled');
                    } else {
                        prevLink.attr('data-page', parseInt(currentPage) - 1);
                        prevLink.on('click', function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            $('html, body').animate({ scrollTop: 0 }, 500);

                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    }

                    prevItem.append(prevLink);
                    paginationList.prepend(prevItem);
                    // Flèche "Suivant"
                    let nextItem = $('<li>').addClass('pagination__item__next');
                    let nextLink = $('<a>').addClass('pagination__link__next')
                        .attr('href', '#')
                        .html('<svg width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
                    if (parseInt(currentPage) != maxPages) {
                        nextLink.attr('data-page', parseInt(currentPage) + 1);
                        nextLink.on('click', function (e) {
                            e.preventDefault();
                            let page = $(this).attr('data-page');
                            ajaxUrl = $(filterForm).attr('action');
                            ajaxUrl = ajaxUrl + '?page=' + page;
                            currentPage = page;
                            $('html, body').animate({ scrollTop: 0 }, 500);

                            fetchPosts(ajaxUrl, values, nonce, action, postType);
                        });
                    } else {
                        nextItem.addClass('disabled');
                    }
                    nextItem.append(nextLink);
                    paginationList.append(nextItem);
                }

                function fetchPosts(url, values, nonce, action, postType) {
                    $('.loader').css('display', 'flex');
                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            'action': action,
                            'nonce': nonce,
                            'values': JSON.stringify(values),
                            'post_type': postType,
                        })
                    })
                        .then(response => response.json())
                        .then(data => {
                            $('.loader').css('display', 'none');
                            if (data.data.html != '') {
                                if (notFoundContainer) {
                                    notFoundContainer.hide();
                                }
                                $('#items-wrapper').html(data.data.html);
                                createPagination(data.data.max_num_pages);
                                $('.pagination__item[data-page="' + currentPage + '"]').addClass('is-active');
                            } else {
                                if (notFoundContainer && $('#items-wrapper').find('.not-found').length === 0) {
                                    notFoundContainer.show();
                                    $('#items-wrapper').html(notFoundContainer);
                                }
                                $('#pagination').html('');
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                }

                fetchPosts(ajaxUrl, values, nonce, action, postType);
            }

        });




    })(jQuery)
}